<ng-template #modaledit let-c="close" let-d="dismiss">
  
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Pesquisar Equipamentos Cadastrados</h4>
  </div>

  <div class="modal-body">

    <div class="box-header">

<form novalidate [formGroup]="formPesquisa" id="formPesquisa" (validSubmit)="submitPesquisa()">
  
      <div class="row">

        <div class="col-md-4">

          <div class="form-group">

            <label for="">Pesquisar pelo campo</label>
            <div class="input-group input-group">
            <select class="form-control" formControlName="parameter" >
              <option value=''>Qualquer dos campos principais</option>
              <option value="ClasseEquipamento">Classe equipamento</option>
              <option value='Nome'>Nome equipamento</option>
              <option value="Descricao">Descricao equipamento</option>
              <option value="Modelo">Modelo</option>
              <option value="NumeroSerie">Nº de serie</option>
              <option value="NumeroPatrimonio">Nº Patrimônio</option>
            </select>
            <div class="input-group-append">
              <button type="button" class="btn btn-light"  title="limpar filtro" (click)="this.formPesquisa.get('parameter').setValue('')"><i
                  class="fa fa-times pr-1 pl-1"></i></button>
            </div>



          </div>

          </div>


        </div>

        <div class="col-md-7">
          <label for="">Campo(s) contém o valor <span class="field-required">(*)</span></label>
          <div class="input-group input-group">

            <input type="text" class="form-control" formControlName="valor" maxlength="30">
            <div class="input-group-append">
              <button type="button" class="btn btn-light"  title="limpar/remover filtro" (click)="this.formPesquisa.get('valor').setValue('')"><i
                  class="fa fa-times pr-1 pl-1"></i></button>
              
            </div>



          </div>





        </div>

        <div class="col-md-1">
          <button type="submit" class="btn btn-primary btn-block btn-bottom" form="formPesquisa">
            <i class="fa fa-search"></i></button>
        </div>


      </div>

    </form>


    

    </div>
    <div class="text-center">
      <span class="text-muted">Selecione para editar</span>
    </div>

    <div class="box-body" style="height: 320px;">

<div class="row">
  <div class="col-md-12">
      <div class="bx-tb-default-t1 pre-scrollable h300">
        <table class="table table-bordered table-hover">
          <thead class="thead-default">
            <tr>
              <th class="text-center"><i *ngIf="this.isLoading" class="fa fa-spinner fa-spin fa-fw pull-left"></i>Classe Equipamento
              </th>
              <th class="text-center">Tipo</th>
              <th class="text-center">Código</th>
              <th class="text-center">Descricao</th>
              <th class="text-center" *ngIf="this.hasQrCode">Qr Code</th>
            </tr>
          </thead>
          <tbody class="tbody-default">
            <tr *ngFor="let cds of cadastrados" class="cp"
              [ngClass]="{'tr-info': c.id == this.idSelected}">
              <td (click)="getById(cds.id, c)">{{ cds.classeEquipamentoStr }}</td>
              <td (click)="getById(cds.id, c)">{{ cds.tipoEquipamentoStr }}</td>
              <td (click)="getById(cds.id, c)">{{ cds.nome }}</td>
              <td (click)="getById(cds.id, c)">{{ cds.descricao }}</td>
              <td *ngIf="this.hasQrCode" class="text-center">
                <a [href]="cds?.qrCodeName" target="_blank">
                  <img *ngIf="cds?.qrCodeName" [src]="cds?.qrCodeName" style="height: 70px; width: 70px;">
                </a>
              </td> 
            </tr>
            <tr *ngFor="let v of this.voids">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td *ngIf="this.hasQrCode"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>

      
    </div>
    <div class="box-footer" style="padding: 3px;">
      <span class="pl-1">Total: <b>{{ this.cadastrados?.length}}</b> </span>
      <span *ngIf="this.isFiltered" class="pl-3 text-primary">(filtrados)</span>
    </div>


  </div>

  <div class="modal-footer">
   
      <div class="col-md-3">
        <button type="button" class="btn btn-light btn-block ml-2" (click)="gerarQrCode()">Gerar Qr Code</button>
      </div>
      <div class="col-md-3">
          <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-3">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light btn-block" (click)="c('Close click')">Fechar</button>
        </div>
      </div>
  </div>
</ng-template>
